import React from 'react';
const links = ['Terms of Service', 'Privacy Policy', 'Refund Policy', 'Contact'];
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-79" data-mp="3ggtzeln15p6t">
      <div className="mx-auto max-w-5xl text-center" data-id="element-80" data-mp="32o4cmezogg8n">
        <p className="font-display text-xl font-black uppercase tracking-tight text-ink" data-id="element-81" data-mp="32pp7k5pwm171">
          DANCE READY™
        </p>
        <nav aria-label="Footer" data-id="element-82" data-mp="36n3gdw9oa6yi">
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-ink/55" data-id="element-83" data-mp="3uesczotj1hl9">
            {links.map(link => <li key={link} data-id="element-84" data-mp="36czunggsbik">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-brand" data-id="element-85" data-mp="3lf58gu5i3vnz">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-ink/40" data-id="element-86" data-mp="2a1jkvdfai24k">
          © 2026 DANCE READY™. All Rights Reserved.
        </p>
      </div>
    </footer>;
}